var _path, _path2, _circle, _circle2, _circle3, _rect;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgSupport = function SvgSupport(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 88 88"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#FF5C32",
    strokeWidth: 4,
    d: "m12.32 57.2 1.848-.322a10 10 0 0 0 8.19-11.215l-.238-1.73A10 10 0 0 0 12.4 35.3l-5.36-.1M76.56 57.64l-3.006-.593a10 10 0 0 1-7.972-11.174l.267-1.94a10 10 0 0 1 9.72-8.634l5.36-.1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#FF5C32",
    strokeWidth: 4,
    d: "M13.87 57.74c-3.785-4.838-6.83-10.243-6.83-16.59C7.04 20.852 23.588 4.4 44 4.4c20.412 0 36.96 16.453 36.96 36.75 0 14.486-8.43 27.015-20.68 33"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 30.5,
    cy: 46.5,
    r: 2.5,
    fill: "#FF5C32"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 57.5,
    cy: 46.5,
    r: 2.5,
    fill: "#FF5C32"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 44.5,
    cy: 43.5,
    r: 2.5,
    fill: "#FF5C32"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 10.08,
    height: 6.67,
    x: 50.182,
    y: 75.606,
    stroke: "#FF5C32",
    strokeWidth: 4,
    rx: 2,
    transform: "rotate(-25.276 50.182 75.606)"
  })));
};
export default SvgSupport;